import { advanceReport } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getAdvancedReportLists(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(advanceReport.advanceReportBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getadvanceReportObject(id) {
          return new Promise((resolve, reject) => {
              axios
                  .get(`${advanceReport.advanceReportBase}${id}/`)
                  .then((res) => {
                      resolve(handleResponse(res));
                  })
                  .catch((err) => {
                      reject(handleError(err));
                  });
          });
      },

         updateAdvanceReportDetails(payload) {
              return new Promise((resolve, reject) => {
                  axios
                      .put(`${advanceReport.advanceReportBase}${payload.id}/`, payload.data)
                      .then((res) => {
                          resolve(handleResponse(res));
                      })
                      .catch((err) => {
                          reject(handleError(err));
                      });
              });
          },
});


